<template>
  <div class="crowdfund-conf">
    <ConfigTable ref="ct" :searchConfig="searchConfig" :tableColumns="tableColumns" :tableData="list" :total="total" @change="loadData" @add="add" @edit="edit" @delete="deleteRow"></ConfigTable>

    <EditCrowdfundConf ref="editDialog" @sure="callEdit"></EditCrowdfundConf>
  </div>
</template>

<script>
import ElementUI from 'element-ui';
import api from '../../../api/activeManagement';
import { switchTypes } from '../../../config';
import { changeDate, prefixZero } from '../../../utils/filter';
import EditCrowdfundConf from './components/EditCrowdfundConf.vue';
import ConfigTable from '@/components/config-table/index.vue';

const searchConfig = [
  { type: 'select', placeholder: '选择状态', key: 'status', options: switchTypes },
  { type: 'input', placeholder: '输入众筹名称', key: 'name' },
  { type: 'button', placeholder: '搜索', icon: 'search', key: 'search' },
  { type: 'button', placeholder: '新增', icon: 'plus', key: 'add' },
]
const tableColumns = [
  { name: 'ID', key: 'id', width: 220, fixed: 'fixed' },
  { name: '众筹名称', key: 'name' },
  { name: '状态', key: 'status', component: ElementUI.Tag, props(val) {
    return { type: val ? 'success' : 'danger' }
  }, valueHandler(val) {
    return val ? '开启' : '关闭'
  } },
  { name: '最多参与人数', key: 'person_num' },
  { name: '获奖号码', key: 'win_num', valueHandler: prefixZero },
  {
    name: '创建时间', key: 'createdAt', valueHandler(val) {
      return changeDate(val)
    }
  },
  {
    name: '更新时间', key: 'updatedAt', valueHandler(val) {
      return changeDate(val)
    }
  },
  { name: '操作', fixed: 'right', actions: ['edit', 'delete'] },
];
const startPageNumber = 1

export default {
  name: 'CrowdfundConf',
  components: { EditCrowdfundConf, ConfigTable }, 
  data() {
    return {
      searchConfig,
      tableColumns,
      total: 0,
      list: [],
    };
  },
  watch: {
    params: {
      handler(val) {
        this.refresh()
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    
  },
  methods: {
    async loadData(params) {
      try {
        const r = await api.getCrowdfundConfList(params)
        const data = r.data
        this.total = data.total
        this.list = data.list
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    refresh() {
      this.$refs.ct.search()
    },
    add() {
      this.$refs.editDialog.open()
    },
    async deleteRow(row) {
      try {
        const r = await this.$confirm("您确定要删除该条数据吗？", "操作提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        await api.deleteCrowdfundConf({ id: row.id })
        this.$message.success('已删除')
        this.refresh()
      } catch (error) {
        console.log(error);
      }
    },
    edit(row) {
      this.$refs.editDialog.open(row)
    },
    async callEdit(r) {
      try {
        const res = await r.isEdit ? api.updateCrowdfundConf(r.data) : api.createCrowdfundConf(r.data)
        this.$message.success(r.isEdit ? '更新成功' : '新增成功')
        this.$refs.editDialog.close()
        setTimeout(() => {
          this.refresh()
        }, 200);
      } catch (error) {
        
      }
    },
    rowAction(action, row) {
      console.log(action, row);
      this[action].call(this, row)
    }
  }
};
</script>

<style lang="scss" scoped>

</style>